// Display label for the stable service_type DB key (CR Track & Trace GPS).
// Mirrors _DISPLAY_MAP["default"] in backend services/service_type_display.py.
const SERVICE_TYPE_LABELS = {
  "LoJack Tracker Passive 1": "Track & Trace GPS 1",
  "LoJack Tracker Passive 2": "Track & Trace GPS 2",
  "LoJack Tracker Passive 3": "Track & Trace GPS 3",
  "LoJack Tracker Passive 4": "Track & Trace GPS 4",
  "LoJack Tracker Passive 5": "Track & Trace GPS 5",
};

export const serviceTypeLabel = (key) => SERVICE_TYPE_LABELS[key] || key || "";
